import type { ReactNode } from 'react';
import { SiteHeader } from './SiteHeader.js';
import { SiteFooter } from './SiteFooter.js';

/**
 * Header, page, footer.
 *
 * `<main id="main">` lives here rather than in each route, because the skip
 * link in the root document points at it — and a target that exists on some
 * pages and not others is a skip link that silently does nothing on the pages
 * somebody most needed it.
 *
 * `flex-1` on the main element keeps the footer at the bottom of short pages
 * without `min-height` arithmetic, which is the version that breaks the first
 * time a page is one line longer than expected.
 */
export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <SiteHeader />
      <main id="main" className="flex-1">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
